import React from "react";
import { StyledWhiteBox } from "./StyledWhiteBox";

const WhiteBox = ({ className = "", children }) => (
  <StyledWhiteBox className={`mls-c-whitebox ${className}`}>
    {children}
  </StyledWhiteBox>
);

export default WhiteBox;
